/**
 * Convert API date/time values to a Date. Backend often sends Unix **seconds**;
 * `new Date(n)` expects **milliseconds**, which produces 1970-era dates if misused.
 */
export function parseApiTimestampToDate(value: unknown): Date | null {
  if (value == null || value === "") return null
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value
  }
  let ms: number
  if (typeof value === "number") {
    if (!Number.isFinite(value)) return null
    ms = value > 0 && value < 1e12 ? value * 1000 : value
  } else if (typeof value === "string") {
    const t = value.trim()
    if (!t) return null
    if (/^\d+$/.test(t)) {
      const n = Number(t)
      if (!Number.isFinite(n)) return null
      ms = t.length >= 13 ? n : n < 1e12 ? n * 1000 : n
    } else {
      const normalized = t.includes(" ") && !t.includes("T") ? t.replace(" ", "T") : t
      ms = new Date(normalized).getTime()
    }
  } else {
    return null
  }
  const d = new Date(ms)
  return Number.isNaN(d.getTime()) ? null : d
}
